var CardStyle;
(function (CardStyle) {
    CardStyle["BLUE_50"] = "blue-50";
    CardStyle["BLUE_100"] = "blue-100";
    CardStyle["LAVENDER_HAZE"] = "lavender-haze";
    CardStyle["INFO"] = "info";
    CardStyle["FROSTED"] = "frosted";
    CardStyle["WARNING"] = "warning";
    CardStyle["DANGER"] = "danger";
    CardStyle["GREEN"] = "green";
    CardStyle["PRIMARY"] = "primary";
    CardStyle["WHITE"] = "white";
    CardStyle["WHITE_WITH_BORDER"] = "white-with-border";
    CardStyle["WHITE_WITH_GREY_BORDER"] = "white-with-grey-border";
    CardStyle["WHITE_WITH_BORDER_DANGER"] = "white-with-border-danger";
    CardStyle["WHITE_WITH_BORDER_WARNING"] = "white-with-border-warning";
    CardStyle["GREY"] = "grey";
    CardStyle["GREY_WITH_BORDER"] = "grey-with-border";
    CardStyle["TRANSPARENT"] = "transparent";
    CardStyle["DANGER_2"] = "danger-2";
})(CardStyle || (CardStyle = {}));
var FlagPosition;
(function (FlagPosition) {
    FlagPosition["TOP"] = "top";
    FlagPosition["BOTTOM"] = "bottom";
    FlagPosition["LEFT"] = "left";
    FlagPosition["RIGHT"] = "right";
})(FlagPosition || (FlagPosition = {}));
var FlagColor;
(function (FlagColor) {
    FlagColor["RED"] = "red";
    FlagColor["BLUE"] = "blue";
    FlagColor["GREEN"] = "green";
    FlagColor["ORANGE"] = "orange";
    FlagColor["YELLOW"] = "yellow";
})(FlagColor || (FlagColor = {}));

export { CardStyle, FlagColor, FlagPosition };
